import { render, staticRenderFns } from "./CardProfile.vue?vue&type=template&id=899ce790&scoped=true&"
import script from "./CardProfile.vue?vue&type=script&lang=js&"
export * from "./CardProfile.vue?vue&type=script&lang=js&"
import style0 from "./CardProfile.vue?vue&type=style&index=0&id=899ce790&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899ce790",
  null
  
)

export default component.exports